import React from "react";
import {
    Box,
    Paper,
    Typography,
    Button,
    Stack,
    useTheme,
} from "@mui/material";
import AndroidIcon from "@mui/icons-material/Android";
import DownloadIcon from "@mui/icons-material/Download";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";

const Downloads = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 3,
                background:
                    theme.palette.mode === "dark"
                        ? "linear-gradient(135deg, #0a0f1e 0%, #0f172a 50%, #1e1b2e 100%)"
                        : "linear-gradient(135deg, #fffbeb 0%, #ffffff 50%, #fefce8 100%)",
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    width: "100%",
                    maxWidth: 520,
                    overflow: "hidden",
                    borderRadius: "20px",
                    border: "1px solid #e5e7eb",
                    background: "#ffffff",
                    boxShadow: "0 20px 35px -10px rgba(0,0,0,0.08)",

                    ...(theme.palette.mode === "dark" && {
                        background: "#111827",
                        border: "1px solid #1f2937",
                    }),
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        background: "linear-gradient(135deg,#f59e0b,#d97706)",
                        py: 4,
                        px: 3,
                        textAlign: "center",
                    }}
                >
                    <AndroidIcon
                        sx={{
                            fontSize: 72,
                            color: "#fff",
                            mb: 1,
                        }}
                    />

                    <Typography
                        variant="h4"
                        sx={{
                            color: "#fff",
                            fontWeight: 700,
                        }}
                    >
                        EBS OMS
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,.9)",
                            mt: 1,
                        }}
                    >
                        Android Mobile Application
                    </Typography>
                </Box>

                {/* Body */}
                <Box sx={{ p: 4 }}>
                    <Stack spacing={3} alignItems="center">
                        <PhoneAndroidIcon
                            sx={{
                                fontSize: 60,
                                color: "primary.main",
                            }}
                        />

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                textAlign: "center",
                                color: "#111827",

                                ...(theme.palette.mode === "dark" && {
                                    color: "#fff",
                                }),
                            }}
                        >
                            Download the Latest APK
                        </Typography>

                        <Typography
                            sx={{
                                textAlign: "center",
                                color: "#6b7280",

                                ...(theme.palette.mode === "dark" && {
                                    color: "#94a3b8",
                                }),
                            }}
                        >
                            Install the latest version of the EBS OMS Android application on
                            your device.
                        </Typography>

                        <Button
                            component="a"
                            href="https://www.dropbox.com/scl/fi/e2cs8u9pwsx0rp8b67n2h/EBS-OMS-V1.0.apk?rlkey=n6ltvqskn3calwhwah81rl19s&st=2z6lw3i4&dl=1"
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            sx={{
                                mt: 2,
                                px: 5,
                                py: 1.4,
                                borderRadius: "10px",
                                textTransform: "none",
                                fontSize: "1rem",
                                fontWeight: 600,
                                backgroundColor: "#f59e0b",

                                "&:hover": {
                                    backgroundColor: "#d97706",
                                },
                            }}
                        >
                            Download APK
                        </Button>

                        <Typography
                            variant="caption"
                            sx={{
                                color: "#9ca3af",
                                textAlign: "center",
                            }}
                        >
                            Compatible with Android 8.0 and above
                        </Typography>
                    </Stack>
                </Box>
            </Paper>
        </Box>
    );
};

export default Downloads;